// extracted by mini-css-extract-plugin
export var askAiIcon = "_m5-j";
export var category = "_m5-9";
export var categoryHeader = "_m5-e";
export var container = "_m5-0";
export var group = "_m5-a";
export var groupItems = "_m5-f";
export var groupSeparator = "_m5-k";
export var loading = "_m5-1";
export var noResults = "_m5-3";
export var placeholder = "_m5-2";
export var resultContent = "_m5-5";
export var resultIcon = "_m5-c";
export var resultItem = "_m5-g";
export var resultMeta = "_m5-8";
export var resultSubtitle = "_m5-7";
export var resultSuffix = "_m5-i";
export var resultTitle = "_m5-6";
export var resultsList = "_m5-4";
export var searchGroup = "_m5-d";
export var selected = "_m5-h";
export var subgroup = "_m5-b";